import { env } from '@/config';

type LogLevel = 'debug' | 'info' | 'warn' | 'error';

const LOG_LEVELS: Record<LogLevel, number> = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3,
};

const currentLevel: LogLevel = env.isDev ? 'debug' : 'warn';

function shouldLog(level: LogLevel): boolean {
  return LOG_LEVELS[level] >= LOG_LEVELS[currentLevel];
}

export const logger = {
  debug: (msg: string, meta?: unknown): void => {
    // biome-ignore lint/suspicious/noConsole: central logger wrapper
    if (shouldLog('debug')) console.debug('[DEBUG]', msg, meta ?? '');
  },
  info: (msg: string, meta?: unknown): void => {
    // biome-ignore lint/suspicious/noConsole: central logger wrapper
    if (shouldLog('info')) console.info('[INFO]', msg, meta ?? '');
  },
  warn: (msg: string, meta?: unknown): void => {
    // biome-ignore lint/suspicious/noConsole: central logger wrapper
    if (shouldLog('warn')) console.warn('[WARN]', msg, meta ?? '');
  },
  error: (msg: string, err?: unknown): void => {
    // biome-ignore lint/suspicious/noConsole: central logger wrapper
    if (shouldLog('error')) console.error('[ERROR]', msg, err ?? '');
  },
};
